import { cn } from '../../lib/utils';
import { UserStatus } from '../../types/user';

interface StatusBadgeProps {
  status: UserStatus;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const getStatusConfig = (status: UserStatus) => {
    switch (status) {
      case 'APPROVED':
      case 'ACTIVE':
        return {
          label: status === 'APPROVED' ? 'APPROVED' : 'ACTIVE',
          className: 'bg-success/10 text-success border border-success/30',
        };
      case 'KYC_VERIFIED':
        return {
          label: 'KYC VERIFIED',
          className: 'bg-info/10 text-info border border-info/30',
        };
      case 'PENDING':
      case 'pending':
        return {
          label: 'PENDING',
          className: 'bg-warning/10 text-warning border border-warning/30',
        };
      case 'KYC_SUBMITTED':
        return {
          label: 'KYC SUBMITTED',
          className: 'bg-info/10 text-info border border-info/30',
        };
      case 'SUSPENDED':
        return {
          label: 'SUSPENDED',
          className: 'bg-destructive/10 text-destructive border border-destructive/30',
        };
      case 'REJECTED':
        return {
          label: 'REJECTED',
          className: 'bg-destructive/10 text-destructive border border-destructive/30',
        };
      case 'ACCREDITED':
        return {
          label: 'ACCREDITED',
          className: 'bg-success/10 text-success border border-success/30',
        };
      default:
        return {
          label: status,
          className: 'bg-muted text-muted-foreground border border-border',
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold',
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
}
